import React, {useState,useEffect} from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import Popup from '../components/Popup';
import { sendAnalyticsData } from '../utilities/analytics';
import Cookies from 'universal-cookie';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const PageLanding = (e) => {

  const [isOpen, setIsOpen] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [isChecked, setIsChecked] = useState(false);
  
  const settings = {
    dots: false,
    infinite: true,
    accessibility: false,
    arrows: false,
    speed: 1800,
    autoplaySpeed: 3000,
    fade: true,
    slidesToShow: 1,
    autoplay: true
  };
  useEffect(() => {
    const cookies = new Cookies();
    cookies.set('event_name', 'BST 2026');
    let token = new URL(window.location.href).searchParams.get('t');
    if (token) {
      cookies.set('t', token, {path: '/'});
    } else {
      cookies.remove('t', token, {path: '/'});
    }

    sendAnalyticsData('View Page','Landing Page')
  }, [])
  
  const navigate = useNavigate();
  const { type } = useParams();

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
    
    if(!isChecked){
      setButtonDisabled(false)
    }else{
      setButtonDisabled(true);
    }
  };

  const togglePopup = (type) => {
    setIsOpen(!isOpen);
  };
  useEffect(() => {
    sendAnalyticsData('View Page','Hint Page')
  }, [])
  
  return (
    <div className='landing-container'>

      <div className='intro-landing'>
        <div className='landing-title'>
          <img className='logo-landing' src='/images/logo.png' alt=''/>
          <h3>Discover your Personal Color Season to<br/>find the colors that suit your best!</h3>
        </div>

        <div className="landing-button d-flex flex-column w-100">
          <Link to={`/expert/result`} className='btn btn-primary d-table w-100 mx-auto' onClick={() => {sendAnalyticsData('Click','Page Scan QR')}}>
            Start
          </Link>
        </div>
      </div>
      
      <Popup isOpen={isOpen} onClose={togglePopup} type={type}>
        <div className='term-condition py-4 px-4'>
          <h2 className='mb-4 text-start'>
            OUR<br/>PRIVACY POLICY
          </h2>
          <div className='term-condition-check pb-2 mb-4'>
            <label className='checkbox'>
              <input
                name='tnc'
                type="checkbox"
                checked={isChecked}
                onChange={handleCheckboxChange}
              />
              <span>
                I have read, understand and accept the <Link to='https://www.wardahbeauty.com/en/privacy-policy' target='_blank' onClick={() => {sendAnalyticsData('Click','Privacy Policy Link')}}>privacy policy</Link>
              </span>
            </label>
          </div>
          <Link to={`/expert/hint`}  onClick={() => {sendAnalyticsData('Click','Go to Real Expert Page')}} className={`btn btn-secondary w-100 ${buttonDisabled ? 'disabled' : ''}`} style={{'color': '#4B4C4E'}}>
            Next
          </Link>
        </div>
      </Popup>
      <div className='powered-copy'>© 2026 PixieLab. All rights reserved. Innovating the future with technology that<br/> excites and transforms. Stay updated with our latest developments and<br/> breakthroughs by visiting our website.</div>
    </div>
  );
};

export default PageLanding;
